// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { UI_STRINGS } from '../../../functions/language/uistrings';
import { ParameterValueReason } from '../../../model/enums/parameter-value-reason';
import { LanguageService } from '../../../services/language.service';
import { TranslationService } from '../../../services/translation-service';

@Pipe({
    name: 'translateChangedFromToValue',
    standalone: false
})
export class TranslateChangedFromToValuePipe implements PipeTransform {
  constructor(
    private translationService: TranslationService,
    private languageService: LanguageService
  ) {}

  transform(
    displayVariableName: boolean,
    from: number,
    to: number,
    valueMetaData?: {
      reason: ParameterValueReason;
      reasonOldValue?: number;
      reasonNewValue?: number;
    },
    parameter?: string
  ): string {
    const language = this.languageService.language;
    const isFromNumber = !isNaN(Number(from));
    let transformedString: string;

    if (isFromNumber) {
      if (displayVariableName) {
        transformedString = this.translationService.translate({
          language,
          key: UI_STRINGS.PARAMETERS.CHANGED_PARAMETER_FROM_TO_VALUE,
          params: { parameter, from, to },
        });
      } else {
        transformedString = this.translationService.translate({
          language,
          key: UI_STRINGS.PARAMETERS.CHANGED_FROM_TO_VALUE,
          params: { from, to },
        });
      }
    } else {
      if (displayVariableName) {
        transformedString = this.translationService.translate({
          language,
          key: UI_STRINGS.PARAMETERS.SET_PARAMETER_TO_VALUE,
          params: { parameter, to },
        });
      } else {
        transformedString = this.translationService.translate({
          language,
          key: UI_STRINGS.PARAMETERS.SET_TO_VALUE,
          params: { to },
        });
      }
    }

    switch (valueMetaData?.reason) {
      case ParameterValueReason.Emission:
        if (valueMetaData.reasonOldValue !== undefined && valueMetaData.reasonNewValue !== undefined) {
          transformedString += `<br>${this.translationService.translate({
            language,
            key: UI_STRINGS.PARAMETERS.AS_A_RESULT_OF_CHANGING_EMISSIONS_FROM_TO,
            params: { from: valueMetaData.reasonOldValue, to: valueMetaData.reasonNewValue },
          })}`;
        } else {
          transformedString += `<br>${this.translationService.translate({
            language,
            key: UI_STRINGS.PARAMETERS.AS_A_RESULT_OF_CHANGING_EMISSIONS,
          })}`;
        }
        break;
      case ParameterValueReason.Energy:
        if (valueMetaData.reasonOldValue !== undefined && valueMetaData.reasonNewValue !== undefined) {
          transformedString += `<br>${this.translationService.translate({
            language,
            key: UI_STRINGS.PARAMETERS.AS_A_RESULT_OF_CHANGING_WORK_FROM_TO,
            params: { from: valueMetaData.reasonOldValue, to: valueMetaData.reasonNewValue },
          })}`;
        } else {
          transformedString += `<br>${this.translationService.translate({
            language,
            key: UI_STRINGS.PARAMETERS.AS_A_RESULT_OF_CHANGING_WORK,
          })}`;
        }
        break;
      case ParameterValueReason.InventoryImport:
        transformedString += `<br>${this.translationService.translate({
          language,
          key: UI_STRINGS.PARAMETERS.AS_A_RESULT_OF_IMPORTING_THE_VALUE,
        })}`;
        break;
    }

    return transformedString;
  }
}
